// src/utils/csvParser.js

/**
 * A simple, lightweight CSV to JSON parser.
 * @param {string} csvText The raw text content of the CSV file.
 * @returns {Promise<Array<Object>>} A promise that resolves to an array of objects.
 */
export const parseCsv = (csvText) => {
  return new Promise((resolve, reject) => {
    try {
      // Split the text into lines, handling both Windows (\r\n) and Unix (\n) line endings.
      const lines = csvText.trim().split(/\r?\n/);

      if (lines.length < 2) {
        // Not enough data to be a valid CSV with headers.
        return resolve([]);
      }

      // Extract headers from the first line.
      // Trim whitespace and handle potential quotes.
      const headers = lines[0].split(',').map(header => header.trim().replace(/"/g, ''));
      
      const jsonData = [];

      // Iterate over the data lines (all lines except the first one).
      for (let i = 1; i < lines.length; i++) {
        const line = lines[i];
        if (!line.trim()) continue; // Skip empty lines

        // A simple regex to handle comma-separated values, including those in quotes.
        const values = line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(val => val.trim().replace(/"/g, ''));
        
        // If a row has a different number of columns than the header, skip it.
        if (values.length !== headers.length) {
          console.warn(`Skipping malformed CSV row ${i + 1}:`, line);
          continue;
        }

        const entry = {};
        for (let j = 0; j < headers.length; j++) {
          entry[headers[j]] = values[j];
        }
        jsonData.push(entry);
      }
      
      resolve(jsonData);
    } catch (error) {
      reject(error);
    }
  });
};